import React from 'react'
import { type PlaceSuggestion } from '../../types/types';
import Pin from '../../components/icons/Pin';

interface Props {
  suggestion: PlaceSuggestion
  onSelect: (mapboxId: string) => {}
}
const Suggestion = ({ suggestion, onSelect }: Props) => {
  return (
    <li
      className='flex flex-col py-2 px-4 cursor-pointer'
      onClick={() => onSelect(suggestion.mapbox_id)}>
      <div className='flex flex-col'>
        <div className='flex items-start'>
          <span className="mr-1"><Pin /></span>
          <p className="font-montserrat text-left">{suggestion.name}</p>
        </div>
        <div className='flex items-start'>
          <span className="mr-1 invisible"><Pin /></span>
          <p className="text-sm font-montserrat text-left">{suggestion.place_formatted}</p>
        </div>
      </div>
    </li>
  )
}

export default Suggestion;